import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Paper, Typography } from '@material-ui/core'

import * as CommunityActionCreators from '../../actions/community'
import * as DoorAccessActionCreators from '../../actions/doorAccess'

import BreadcrumbContainer from '../controls/BreadcrumbContainer'
import LoadingStatus from '../controls/LoadingStatusContainer'
import PageTitle from '../controls/PageTitle'
import DoorAccessDetailsContainer from './DoorAccessDetailsContainer'
import DoorAccessAccessListContainer from './DoorAccessAccessListContainer'

class DoorAccessDetailsPage extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    /* mapped state */
    communities: PropTypes.object.isRequired,
    doorAccesses: PropTypes.object.isRequired,
    /* mapped dispatch */
    doorAccessActions: PropTypes.object.isRequired,
    communityActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      communities: state.communities,
      doorAccesses: state.doorAccesses,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      communityActions: bindActionCreators(CommunityActionCreators, dispatch),
      doorAccessActions: bindActionCreators(DoorAccessActionCreators, dispatch),
    }
  }

  static styles = (theme) => ({
    paper: theme.paper,
  })

  componentDidMount() {
    this.props.doorAccessActions.getDoorAccess(this.accessId())
  }

  componentDidUpdate(prevProps) {
    const accessId = this.accessId()
    const communityId = this.communityId()
    const prevDoorAccess = prevProps.doorAccesses[accessId] || {}

    if (!prevDoorAccess.parent_community_id && communityId) {
      this.props.communityActions.fetchCommunity(communityId)
    }
  }

  doorAccess() {
    return this.props.doorAccesses[this.accessId()] || {}
  }

  communityId() {
    return this.doorAccess().parent_community_id || 0
  }

  community() {
    return this.props.communities[this.communityId()] || {}
  }

  accessId() {
    return parseInt(this.props.match.params.accessId, 10)
  }

  breadcrumb() {
    const communityId = this.communityId()
    const breadcrumb = []
    if (communityId) {
      breadcrumb.push({ title: this.community().name || 'Community', to: `/communities/${communityId}` })
    }
    breadcrumb.push({ title: 'Door Access User' })
    return breadcrumb
  }

  render() {
    const { classes } = this.props
    const accessId = this.accessId()
    const communityId = this.communityId()

    return (
      <>
        <PageTitle title="Door Access User" />
        <LoadingStatus />

        <BreadcrumbContainer items={this.breadcrumb()} />

        <Typography variant="h6">Door Access User</Typography>

        <Paper className={classes.paper} elevation={0}>
          <DoorAccessDetailsContainer accessId={accessId} />
        </Paper>

        <Paper className={classes.paper} elevation={0}>
          <DoorAccessAccessListContainer
            accessId={accessId}
            communityId={communityId}
          />
        </Paper>
      </>
    )
  }
}

export default connect(
  DoorAccessDetailsPage.mapStateToProps,
  DoorAccessDetailsPage.mapDispatchToProps,
)(withStyles(DoorAccessDetailsPage.styles)(DoorAccessDetailsPage))
